<template>

    <div class="row default mb-4">
        <div class="col-lg-12">
            <div class="np-header1 np-pb-3">{{ $t("UI.dashboard.welcome") }},  {{ userStore.userShortName }}</div>
        </div>
    </div>
    <div class="row flex-grow-1">
        <div class="col-lg-5 d-flex flex-column h-100">     

            <div class="d-flex justify-content-between mb-2">
                <div class="np-header3 vertical-align-center">
                    <svg class="np-mr-2"><use href="@/assets/images/icons/folder.svg#icon"></use></svg> {{ $t("UI.dashboard.projectAndSpaces") }}
                </div>
                <button class="np-btn np-btn-info-outline" @click="showSelectToCreate">
                    <svg class="icon"><use href="@/assets/images/icons/plus.svg#icon"></use></svg>
                    <span class="me-1">{{ $t("UI.dashboard.create") }}</span>
                    <svg><use href="@/assets/images/icons/folder-open.svg#icon"></use></svg>
                </button>                
            </div>
            <div class="np-widgets-panel pb-4">
                <div class="np-widget">
                    <div class="np-widget-top">
                        <p class="np-font-l np-f-medium np-lh-l">{{ userStats.spaces_projects.total }}</p>
                        <svg><use href="@/assets/images/icons/calendar-empty.svg#icon"></use></svg>
                    </div>                        
                    <div class="np-widget-bottom">
                        <span class="np-lh-m">{{ $t("UI.summary.totalProjects") }}</span>
                        <svg style="width: 20px; height: 20px;"><use href="@/assets/images/icons/eye20.svg#icon"></use></svg>
                    </div>
                </div>

                <div class="np-widget">
                    <div class="np-widget-top">
                        <p class="np-font-l np-f-medium np-lh-l">{{ userStats.spaces_projects.active }}</p>
                        <svg class="np-color-success"><use href="@/assets/images/icons/calendar-complete.svg#icon"></use></svg>
                    </div>
                    <div class="np-widget-bottom">
                        <span class="np-lh-m">{{ $t("UI.summary.activeProjects") }}</span>
                        <svg style="width: 20px; height: 20px;"><use href="@/assets/images/icons/eye20.svg#icon"></use></svg>
                    </div>
                </div>
                
                <div class="np-widget">
                    <div class="np-widget-top">
                        <p class="np-font-l np-f-medium np-lh-l">{{ userStats.spaces_projects.overdue }}</p>
                        <svg class="np-color-danger"><use href="@/assets/images/icons/calendar-fail.svg#icon"></use></svg>
                    </div>                        
                    <div class="np-widget-bottom">
                        <span class="np-lh-m">{{ $t("UI.summary.overdueProjects") }}</span>
                        <svg style="width: 20px; height: 20px;"><use href="@/assets/images/icons/eye20.svg#icon"></use></svg>
                    </div>
                </div>
            </div>    

            <div class="np-header3 vertical-align-center mb-2">
                <svg class="np-mr-2"><use href="@/assets/images/icons/folder.svg#icon"></use></svg> {{ $t("UI.projects") }}
            </div>

            <div class="np-panel flex-grow-1">
                <div class="np-panel-header row p-2 pt-0">
                    <div class="col-12 pt-0 bordered mb-2">
                        <Navigation 
                            :tabs="[
                                {
                                    id: 'active',
                                    label: $t('UI.summary.active'),
                                    icon: require('@/assets/images/icons/active.svg') + '#icon'
                                },
                                {
                                    id: 'archived',
                                    label: $t('UI.summary.archived'),
                                    icon: require('@/assets/images/icons/archive.svg') + '#icon'
                                },
                                {
                                    id: 'deleted',
                                    label: $t('UI.summary.deleted'),
                                    icon: require('@/assets/images/icons/trash.svg') + '#icon'
                                }                             
                            ]" 
                            :classes="['pt-2', 'pb-2']" 
                            activeTab="active" 
                            @callSwitchScreen="handleTabSwitch"
                        />
                    </div>
                    <div class="col-12 d-flex justify-content-between">
                        <select class="np-select" v-model="spacesSorting" @change="handleSpacesSortingChange">
                            <option value="" disabled selected>{{ $t("sort.placeholder") }}</option>
                            <option value="name" data-direction="asc">{{ $t("sort.byNameAsc") }}</option>
                            <option value="name" data-direction="desc">{{ $t("sort.byNameDesc") }}</option>
                            <option value="completion_percent" data-direction="desc">{{ $t("sort.byPercentAsc") }}</option>
                            <option value="completion_percent" data-direction="asc">{{ $t("sort.byPercentDesc") }}</option>
                        </select>
                        <div class="d-flex">
                            <div class="np-field-group np-with-icon-right me-2">
                                <input type="text" class="np-text-input np-outline" placeholder="Поиск" v-model="filters.title"/>
                                <svg class="field-icon at-left"><use href="@/assets/images/icons/search.svg#icon"></use></svg>
                            </div>
                            <button class="np-btn np-btn-primary-lighter np-p-custom-0">
                                <svg><use href="@/assets/images/icons/filter.svg#icon"></use></svg>
                            </button>                        
                        </div>
                    </div>
                </div>
                <div class="np-panel-body np-overflow-hidden np-flex-1 np-p-0">
                    <div class="np-group np-group-column">
                        <AccordionList 
                            :items="sortedSpaces"
                            @onItemExpand="expandSpace"
                            @onSubItemExpand="expandProject"
                        >
                            <template #item-row="{ item, toggle }">
                                <div class="item-row">
                                    <button class="np-btn-sm np-toggler me-4" :class="{ 'expanded': item.expanded }" @click="expandSpace(item.id)" role="button"></button>
                                    <div class="title" @click="expandSpace(item.id)" role="button">
                                        {{ item.title }}
                                    </div>
                                    <div class="np-badge-s np-danger me-2">
                                        <svg class="icon20"><use href="@/assets/images/icons/bellx20.svg#icon"></use></svg>
                                    </div>
                                    <div class="np-badge-s np-light me-2">
                                        <svg class="icon"><use href="@/assets/images/icons/folder.svg#icon"></use></svg>
                                        {{ item.count_projects }}
                                    </div>
                                    <div class="dropdown dropstart" data-bs-auto-close="true">
                                        <button 
                                            class="np-btn np-outline"
                                            role="button" 
                                            data-bs-toggle="dropdown" 
                                            aria-expanded="false"
                                        >
                                            <svg><use href="@/assets/images/icons/dots-vertical.svg#icon"></use></svg> 
                                        </button>
                                        <ul class="dropdown-menu" :aria-labelledby="'spaceDropdownMenuLink' + item.id">
                                            <li class="dropdown-item">
                                                <button type="button" class="np-btn np-btn-transparent py-0" @click="showEditProject(item.id, 0)">
                                                    <svg><use href="@/assets/images/icons/folder.svg#icon"></use></svg> {{ $t("UI.summary.newProject") }}
                                                </button>
                                            </li>
                                            <li class="dropdown-item">
                                                <button type="button" class="np-btn np-btn-transparent py-0" @click="showEditSpace(item.id)">
                                                    <svg><use href="@/assets/images/icons/edit.svg#icon"></use></svg> {{ $t("UI.summary.spaceEdit") }}
                                                </button>
                                            </li>
                                            <li class="dropdown-item">
                                                <button type="button" class="np-btn np-btn-transparent py-0" @click="showArch(0, item.id)">
                                                    <svg><use href="@/assets/images/icons/archive.svg#icon"></use></svg> {{ $t("UI.summary.spaceArchive") }}
                                                </button>
                                            </li>
                                            <li class="dropdown-item">
                                                <button type="button" class="np-btn np-btn-transparent py-0" @click="showDel(0, item.id)">
                                                    <svg class="np-color-danger"><use href="@/assets/images/icons/trash.svg#icon"></use></svg> {{ $t("UI.summary.spaceDelete") }}
                                                </button>
                                            </li>
                                            <li class="dropdown-item">
                                                <button type="button" class="np-btn np-btn-transparent py-0" @click="showInvite(0, item.id)">
                                                    <svg><use href="@/assets/images/icons/user-add.svg#icon"></use></svg> {{ $t("UI.summary.spaceInvite") }}
                                                </button>
                                            </li>                            
                                        </ul>
                                    </div>
                                </div>
                            </template>
                            <template #sub-item="{ item }">
                                <div 
                                    class="sub-item" 
                                    v-for="sItem in item.subItems" 
                                    :key="sItem.id"
                                >
                                    <div class="item-title">
                                        <svg class="icon" @click="() => expandProject(sItem.id)"><use href="@/assets/images/icons/folder.svg#icon"></use></svg>
                                        <div class="np-flex-1" @click="() => expandProject(sItem.id)">{{ sItem.name }}</div>
                                        <div class="np-badge-s np-danger me-2">
                                            <svg class="icon20"><use href="@/assets/images/icons/bellx20.svg#icon"></use></svg>
                                        </div>
                                        <div class="dropdown dropstart" data-bs-auto-close="true">
                                            <button 
                                                class="np-btn np-outline"
                                                role="button" 
                                                data-bs-toggle="dropdown" 
                                                aria-expanded="false"
                                            >
                                                <svg><use href="@/assets/images/icons/dots-vertical.svg#icon"></use></svg> 
                                            </button>
                                            <ul class="dropdown-menu" :aria-labelledby="'projectDropdownMenuLink' + item.id">
                                                <li class="dropdown-item">
                                                    <button type="button" class="np-btn np-btn-transparent py-0" @click="showEditProject(item.id, sItem.id)">
                                                        <svg><use href="@/assets/images/icons/edit.svg#icon"></use></svg> {{ $t("UI.summary.spaceEdit") }}
                                                    </button>
                                                </li>
                                                <li class="dropdown-item">
                                                    <button type="button" class="np-btn np-btn-transparent py-0" @click="showArch(1, sItem.id)">
                                                        <svg><use href="@/assets/images/icons/archive.svg#icon"></use></svg> {{ $t("UI.summary.spaceArchive") }}
                                                    </button>
                                                </li>
                                                <li class="dropdown-item">
                                                    <button type="button" class="np-btn np-btn-transparent py-0" @click="showDel(1, sItem.id)">
                                                        <svg class="np-color-danger"><use href="@/assets/images/icons/trash.svg#icon"></use></svg> {{ $t("UI.summary.spaceDelete") }}
                                                    </button>
                                                </li>
                                                <li class="dropdown-item">
                                                    <button type="button" class="np-btn np-btn-transparent py-0" @click="showInvite(1, sItem.id)">
                                                        <svg><use href="@/assets/images/icons/user-add.svg#icon"></use></svg> {{ $t("UI.summary.spaceInvite") }}
                                                    </button>
                                                </li>                            
                                            </ul>                                
                                        </div>
                                    </div>

                                    <div class="item-description ps-1" v-if="sItem.expanded">
                                        <div class="mt-1 ms-4 ps-4">
                                            <div class="grid-container">
                                                <div class="cell content-width d-flex flex-column align-items-start">
                                                    <span class="np-font-s np-pb-1">{{ $t("UI.project.complete") }}: {{ sItem.completion_percent }}%</span>
                                                    <div class="np-progressbar w-100">
                                                        <div class="np-progressbar-track np-progressbar-success" :style="{'width': sItem.completion_percent +'%', 'max-width': '100%'}"></div>
                                                    </div>                                         
                                                </div>
                                                <div class="cell remaining-width"></div>
                                                <div class="cell content-width">
                                                    <div class="np-font-s np-lh-m np-pr-2">
                                                        {{ $t("UI.dashboard.projectDeadline") }}: {{ sItem.date_planned_end ? localeDate(sItem.date_planned_end) : $t("UI.summary.notAssigned") }}
                                                    </div>                                        
                                                </div>
                                                <div class="cell remaining-width">
                                                    <IndicatorDaysTo :dateStart="sItem.date_planned_start" :dateEnd="sItem.date_planned_end" v-if="sItem.date_planned_end" classes="np-transparent np-borderless"/>                                        
                                                </div> 
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>                                                    
                        </AccordionList>
                    </div>
                </div>
            </div>                   

        </div>
        <div class="col-lg-7 d-flex flex-column h-100">

            <div class="np-header3 vertical-align-center mb-2">
                <svg class="np-mr-2"><use href="@/assets/images/icons/folder.svg#icon"></use></svg> {{ selectedProject ? selectedProject.name : $t("UI.dashboard.projectInfo") }}
            </div>

            <div class="np-panel p-3 flex-grow-1 summary-panel" v-if="selectedProject">
                <div class="np-panel-body np-flex-1 np-overflow-hidden p-4">
                    <div class="np-group justify-content-between">
                        <div class="np-header3 vertical-align-center mt-3 mb-4">
                            <svg class="np-mr-2"><use href="@/assets/images/icons/calendar-empty.svg#icon"></use></svg> {{ $t("UI.summary.taskSummary") }}
                        </div>
                        <a :href="'/project/' + selectedProject.id" class="np-btn np-btn-info-outline">
                            <span class="me-1">{{ $t("UI.summary.gotoProject") }}</span>
                            <svg class="icon"><use href="@/assets/images/icons/folder-open.svg#icon"></use></svg>
                            <svg><use href="@/assets/images/icons/arrow-right.svg#icon"></use></svg>
                        </a>   
                    </div>
                    <div class="np-widgets-panel pb-4">
                        <div class="np-widget summary-widget">
                            <div class="np-widget-top">
                                <p class="np-font-l np-f-medium np-lh-l">{{ selectedProject.tasks_info.completed }} {{ $t("UI.dashboard.from") }} {{ selectedProject.tasks_info.total }}</p>
                                <svg><use href="@/assets/images/icons/calendar-empty.svg#icon"></use></svg>
                            </div>                        
                            <div class="np-widget-bottom">
                                <span class="np-lh-m">{{ $t("UI.dashboard.toCompleted") }}</span>
                                <svg style="width: 20px; height: 20px;"><use href="@/assets/images/icons/eye20.svg#icon"></use></svg>
                            </div>
                        </div>

                        <div class="np-widget summary-widget">
                            <div class="np-widget-top">
                                <p class="np-font-l np-f-medium np-lh-l">{{ selectedProject.tasks_info.completed }}</p>
                                <svg class="np-color-success"><use href="@/assets/images/icons/calendar-complete.svg#icon"></use></svg>
                            </div>
                            <div class="np-widget-bottom">
                                <span class="np-lh-m">{{ $t("UI.dashboard.toToday") }}</span>
                                <svg style="width: 20px; height: 20px;"><use href="@/assets/images/icons/eye20.svg#icon"></use></svg>
                            </div>
                        </div>
                        
                        <div class="np-widget summary-widget">
                            <div class="np-widget-top">
                                <p class="np-font-l np-f-medium np-lh-l">{{ selectedProject.tasks_info.workload }}</p>
                                <svg class="np-color-warning"><use href="@/assets/images/icons/calendar-expire.svg#icon"></use></svg>
                            </div>                        
                            <div class="np-widget-bottom">
                                <span class="np-lh-m">{{ $t("UI.dashboard.toExpired") }}</span>
                                <svg style="width: 20px; height: 20px;"><use href="@/assets/images/icons/eye20.svg#icon"></use></svg>
                            </div>
                        </div>

                        <div class="np-widget summary-widget">
                            <div class="np-widget-top">
                                <p class="np-font-l np-f-medium np-lh-l">{{ selectedProject.tasks_info.overdue }}</p>
                                <svg class="np-color-danger"><use href="@/assets/images/icons/calendar-fail.svg#icon"></use></svg>
                            </div>                        
                            <div class="np-widget-bottom">
                                <span class="np-lh-m">{{ $t("UI.dashboard.toFailed") }}</span>
                                <svg style="width: 20px; height: 20px;"><use href="@/assets/images/icons/eye20.svg#icon"></use></svg>
                            </div>
                        </div>                        
                    </div> 
                    
                    <div class="np-header3 vertical-align-center mt-3 mb-4">
                        <svg class="np-mr-2"><use href="@/assets/images/icons/team.svg#icon"></use></svg> 
                        {{ $t("UI.team.title") }}
                        <div class="ps-2 pe-2 np-font-ml np-color-freeze">7/10</div>
                        <button type="button" class="np-btn np-link py-0" @click="showInvite(1, selectedProject.id)">
                            <svg><use href="@/assets/images/icons/user-add.svg#icon"></use></svg>
                        </button>
                    </div>

                    <div class="np-panel np-flex-1 np-overflow-hidden summary-widget">
                        <PerfectScrollbar>
                            <table class="np-table h-100">
                                <thead class="np-table-header">
                                    <tr class="np-table-row">
                                        <th class="np-table-header-cell" style="width: 25%;">
                                            <div class="np-group">
                                                <div class="flex-grow-1">{{ $t("sort.user") }}</div>
                                                <button class="np-btn-link" @click="attachSorting('name')">
                                                    <img class="np-ml-1 np-mr-1" :src="sortIcon('user')" /> 
                                                </button>
                                            </div>
                                        </th>
                                        <th class="np-table-header-cell" style="width: 35%;">
                                            <div class="np-group">
                                                <div class="flex-grow-1">{{ $t("sort.userTasks") }}</div>
                                                <button class="np-btn-link" @click="attachSorting('info')">
                                                    <img class="np-ml-1 np-mr-1" :src="sortIcon('task')" /> 
                                                </button>
                                            </div>
                                        </th>                                                          
                                        <th class="np-table-header-cell">
                                            <div class="np-group">
                                                <div class="flex-grow-1">{{ $t("sort.busy") }}</div>
                                                <button class="np-btn-link" @click="attachSorting('busy')">
                                                    <img class="np-ml-1 np-mr-1" :src="sortIcon('busy')" /> 
                                                </button>
                                            </div>
                                        </th>  
                                        <th class="np-table-header-cell">
                                            <div class="np-group">
                                                <div class="flex-grow-1">{{ $t("sort.effectivity") }}</div>
                                                <button class="np-btn-link" @click="attachSorting('effectivity')">
                                                    <img class="np-ml-1 np-mr-1" :src="sortIcon('effectivity')" /> 
                                                </button>
                                            </div>
                                        </th>                                                                                                                                                                                                                 
                                    </tr>
                                </thead>
                                <tbody class="np-table-body">
                                    <template v-for="member in this.sortedProjectTeam">
                                        <tr class="np-table-row">
                                            <td class="np-table-cell">
                                                <CobaltProfilesList :users="[member]" :short="false" :wrapperClasses="mt-2" />
                                            </td>
                                            <td class="np-table-cell">
                                                <div class="row np-nowrap">
                                                    <div class="col pe-0">
                                                        <div class="np-group align-items-center">
                                                            <svg class="np-mr-1"><use href="@/assets/images/icons/calendar-empty.svg#icon"></use></svg>                            
                                                            <span>{{ member.statistics.summary_tasks.total }}</span>
                                                        </div>
                                                    </div>
                                                    <div class="col pe-0">
                                                        <div class="np-group np-color-success align-items-center">
                                                            <svg class="np-mr-1"><use href="@/assets/images/icons/calendar-complete.svg#icon"></use></svg>                            
                                                            <span>{{ member.statistics.summary_tasks.completed }}</span>
                                                        </div>
                                                    </div>
                                                    <div class="col pe-0">
                                                        <div class="np-group np-color-danger align-items-center">
                                                            <svg class="np-mr-1"><use href="@/assets/images/icons/calendar-fail.svg#icon"></use></svg>         
                                                            <span>{{ member.statistics.summary_tasks.active }}</span>  
                                                        </div>
                                                    </div>
                                                    <div class="col pe-0">
                                                        <div class="np-group np-color-warning align-items-center">
                                                            <svg class="np-mr-1"><use href="@/assets/images/icons/calendar-expire.svg#icon"></use></svg>         
                                                            <span>{{ member.statistics.summary_tasks.overdue }}</span>
                                                        </div>
                                                    </div>
                                                </div>                                                                                                                   
                                            </td>
                                            <td class="np-table-cell">{{ member.statistics.workload.percentage }}%</td>
                                            <td class="np-table-cell">{{ member.statistics.efficiency.percentage }}</td>
                                        </tr>
                                    </template>
                                </tbody>                                                                                         
                            </table>
                        </PerfectScrollbar>
                    </div>                    
                </div>
            </div>  
          
            <div class="np-panel justify-content-center flex-grow-1" v-else>
                <div class="np-panel-body np-overflow-hidden align-items-center p-4">
                    {{ $t("UI.summary.selectProjectOrCreate") }}
                </div>
            </div>              

        </div>        
    </div>

    <SpaceModal
        modalID='modalSpace' 
        @refresh="getPreparedData"
        ref="spaceModal"     
    />

    <ProjectModal 
        modalID='modalProject' 
        @refresh="refreshSpaces"
        ref="projectModal" 
    />

    <InviteModal 
        modalID='modalInviteDashboard' 
        modalSize="modal-md" 
        modalPosition="center" 
        ref="InviteModalDashboard" 
        class="cobalt-base-dialog" 
    />
    
    <SelectSOPModal
        modalID='modalSOPCreateID' 
        modalSize="modal-lg" 
        modalPosition="center" 
        ref="SOPModal" 
        class="cobalt-base-dialog" 
        :spaces="listSpaces"
        @createSpace="showEditSpace"
        @createProject="showEditProject"
    />    
</template>

<script>
import { useUserStore } from '@/stores/userStore'
import { useDashboardStore } from "@/stores/dashboardStore"

import SpaceModal from '@/components/modals/SpaceModal.vue'
import InviteModal from "@/components/modals/InviteModal.vue"
import SelectSOPModal from "@/components/modals/SelectSOPModal.vue"
import Navigation from "@/components/elements/Navigation.vue"
import IndicatorDaysTo  from "@/components/elements/IndicatorDaysTo.vue" 
import AccordionList from "@/components/elements/AccordionList.vue"
import CobaltProfilesList from '../parts/CobaltProfilesList.vue'
import { localeDate, localeDateTime, eventDate, nameColor, priorityValues } from '@/utils/format'
import { mapGetters, mapActions } from 'vuex'
import Config from '../../../config'
import { confirm } from "@/utils/confirmation.js"
import ProjectModal from '@/components/modals/ProjectModal.vue'
import { Dropdown } from 'bootstrap'

function compareValues(a, b) {
  if (typeof a === 'string' && typeof b === 'string') {
    return a.localeCompare(b, undefined, { numeric: true }); // Сравнение строк с учетом чисел
  }
  if (a < b) return -1;
  if (a > b) return 1;
  return 0;
}

function daysTo(date, dateActualEnd) {
    if (dateActualEnd !== null && dateActualEnd !== undefined) return -1;
    if (date === null || date === undefined) return -1;

    const end = date;
    const current = new Date().getTime() / 1000;

    if (end > 0 && current < end) {
        return parseInt((end - current) / 86400);
    }
    return 0;
}

function priorityTo(value) {
    let newValue = 0
    switch (value) {
        case 0: newValue = 0; break;
        case 1: newValue = 4; break;
        case 2: newValue = 3; break;
        case 3: newValue = 2; break;
        case 4: newValue = 1; break;
    } 

    return newValue
}

function sortByMultipleFields(array, sorts) {
    return array.sort((a, b) => {

        const activeSorts = Object.entries(sorts)
        .filter(([field, direction]) => direction !== 'none')
        .map(([field, direction]) => ({ field, direction }))

        for (const { field, direction } of activeSorts) {
            const multiplier = direction === 'desc' ? -1 : 1

            let valueA, valueB
            if (field === 'deadline') {
                valueA = daysTo(a.date_planned_end, a.date_actual_end)
                valueB = daysTo(b.date_planned_end, b.date_actual_end) 
            } else if (field === 'priority') {
                valueA = priorityTo(a.priority)
                valueB = priorityTo(b.priority)
            } else {                    
                valueA = a[field]
                valueB = b[field]
            }

            const result = compareValues(valueA, valueB);
            if (result !== 0) return result * multiplier;
        }

        return 0
    })
}

const SPACE_STATUS = {
  ACTIVE: 'active',
  ARCHIVED: 'archived',
  DELETED: 'deleted',
}

export default {
    components: {
        Navigation,
        IndicatorDaysTo,
        AccordionList,
        CobaltProfilesList,
        SpaceModal,
        InviteModal,
        SelectSOPModal,
        ProjectModal
    },
    data() {
        return {
            Config,
            spacesStatus: SPACE_STATUS.ACTIVE,
            userStats: {
                spaces_projects: {
                    "total": 0,
                    "active": 0,
                    "overdue": 0
                }
            },
            listSpaces: [],
            selectedProject: null,
            selectedProjectTeam: null,
            filters: {
                title: '',
                name: '',
                deadline: null,
                status: '',
                percent: 100,
                performers: [],
                priority: [],
                files: 0,
                date_planned_start: null,
                date_planned_end: null
            },                       
            sSorts: {
                title: 'none'
            }, 
            pSorts: {
                title: 'none'
            },                       
            uSorts: {
                user: 'none',
                task: 'none',                
                busy: 'none',
                effectivity: 'none'
            }, 
            spacesSorting: '',
            projectsSorting: '',
            usersSorting: ''           
        }
    },
    beforeMount: async function () {
        await this.dashboardStore?.init()
        this.getUserStats()
        this.getPreparedData()
    },
    computed: {   
        dashboardStore() {
            return useDashboardStore()
        },  
        userStore() {
            return useUserStore()
        },                           
        sortedTaskList: {
            get() {
                const searchTerm = this.filters.name.trim().toLowerCase()
                const fieldsToSearch = ['title', 'status', 'percent']

                if (this.tasksList.tasks) {
                    const tl = sortByMultipleFields(this.tasksList.tasks, this.sorts)

                    const result = tl.filter(item => {
                        return fieldsToSearch.some(field => 
                            String(item[field]).toLowerCase().includes(searchTerm)
                        )
                    })
                                        
                    return result
                } else {
                    return []
                }
            }
        }, 
        sortedProjectTeam: {
            get() {
                const searchTerm = this.filters.name.trim().toLowerCase()
                const fieldsToSearch = ['busy', 'effectivity']

                if (this.selectedProjectTeam) {
                    const tl = sortByMultipleFields(this.selectedProjectTeam, this.uSorts)

                    const result = tl.filter(item => {
                        return fieldsToSearch.some(field => 
                            String(item[field]).toLowerCase().includes(searchTerm)
                        )
                    })
                                        
                    return result
                } else {
                    return []
                }
            }
        },
        sortedSpaces: {
            get() {
                const searchTerm = this.filters.title.trim().toLowerCase()
                const fieldsToSearch = ['title']
                const spaces = this.listSpaces

                if (spaces) {
                    const tl = sortByMultipleFields(spaces, this.sSorts)                                      

                    const result = tl.filter(item => {
                        return fieldsToSearch.some(field => 
                            String(item[field]).toLowerCase().includes(searchTerm)
                        )
                    })

                    return result

                } else {
                    return []
                }
            }
        }              
    },
    methods: {
        ...mapActions('project', { getProjectInfo: 'info', projectsList: 'list', addProject: 'saveProject', projectDelete: 'delete' }),
        ...mapGetters('project', { getProjectsList: 'getList' }), 

        localeDate,
        localeDateTime,

        sortIcon(field) {
            const direction = this.uSorts[field]
            if (direction === 'asc') {
                return require('@/assets/images/icons/sort-asc.svg#icon')
            } else if (direction === 'desc') {
                return require('@/assets/images/icons/sort-desc.svg#icon')
            } else if (direction === 'none') {
                return require('@/assets/images/icons/sort-none.svg#icon')
            }
            return ''
        },

        attachSorting(field) {  
            return         
            if (!(field in this.uSorts)) {
                console.error(`Поле "${field}" не существует в объекте sorts.`)
                return
            }

            Object.keys(this.uSorts).forEach((key) => {
                if (key !== field) {
                    this.uSorts[key] = 'none'
                }
            })
            
            const currentValue = this.uSorts[field];

            if (currentValue === 'none') {
                this.uSorts[field] = 'asc'
            } else if (currentValue === 'asc') {
                this.uSorts[field] = 'desc'
            } else {
                this.uSorts[field] = 'none'
            }
        }, 

        handleSpacesSortingChange(event) {
            const selectedOption = event.target.options[event.target.selectedIndex]
            const selectedField = selectedOption.value
            const selectedDirection = selectedOption.dataset.direction

            //this.attachProjectsSorting(selectedField, selectedDirection)
        },
        
        async getUserStats() {
            const loadedStats = await this.dashboardStore.fetchUserStats()
            
            if (loadedStats) {
                this.userStats = loadedStats
            }
        },

        async refreshSpaces() {
            await this.dashboardStore.fetchSpaces()
            await this.getPreparedData()
        },

        async getPreparedData() {
            this.listSpaces = this.dashboardStore.spaces?.map(item => ({
                ...item,
                subItems: item.projects.map(project => ({
                    ...project,
                    expanded: false,
                })),
                expanded: false
            }))
        },

        async expandSpace(spaceId) {
            this.listSpaces.forEach(space => {
                if (space.id == spaceId) {
                    space.expanded = !space.expanded
                } else {
                    space.expanded = false
                }
            })
        },

        async expandProject(projectId) {
            this.selectedProject = await this.dashboardStore.projectInfo(projectId)
            this.selectedProjectTeam = await this.dashboardStore.projectTeam(this.selectedProject.id)

            for (const space of this.listSpaces) {
                for (const item of space.subItems) {
                    if (item.id === projectId) {
                        item.info = this.selectedProject
                        item.expanded = true
                    } else {
                        item.expanded = false
                    }
                }
            }
        },

        showSelectToCreate() {
            this.$refs.SOPModal.shows()
        },

        showEditSpace(id) {
            if (this.listSpaces) {
                const space = this.listSpaces.find(s => s.id === id)
                this.$refs.spaceModal.shows(space)
            } else {
                this.$refs.spaceModal.shows()
            }
        },
        
        showEditProject(spaceId, projectId) {
            this.$refs.projectModal.shows(spaceId, projectId)
        },

        async showArch(type, id) {
            if (type === 0) {
                const space = this.listSpaces.find(s => s.id === id)
                const confirmed = await confirm(space.title, this.$t("UI.confirmArchive"), this.$t("UI.ok"), this.$t("UI.cancel"))

                if (!confirmed) return

                await this.dashboardStore.archiveSpace(id)
            } else {
                let project = {}

                this.listSpaces.forEach((item) => {
                    item.projects.forEach((sItem) => {
                        if (sItem.id === id) {
                            project = sItem
                        }
                    })
                })
                const confirmed = await confirm(project.name, this.$t("UI.confirmArchive"), this.$t("UI.ok"), this.$t("UI.cancel"))

                if (!confirmed) return
                await this.dashboardStore.archiveProject(projectId)
            }

            this.getPreparedData()
        },

        async showDel(type, id) {
            if (type === 0) {
                const space = this.listSpaces.find(s => s.id === id)
                const confirmed = await confirm(space.title, this.$t("UI.confirmDelete"), this.$t("UI.ok"), this.$t("UI.cancel"))    

                if (!confirmed) return

                await this.dashboardStore.deleteSpace(id)                
            } else {
                let project = {}

                this.listSpaces.forEach((item) => {
                    item.projects.forEach((sItem) => {
                        if (sItem.id === id) {
                            project = sItem
                        }
                    })
                })
                const confirmed = await confirm(project.name, this.$t("UI.confirmDelete"), this.$t("UI.ok"), this.$t("UI.cancel"))

                if (!confirmed) return

                await this.dashboardStore.deleteProject(id)
            }

            this.getPreparedData()
        }, 
        
        showInvite(type, id) {
            this.$refs.InviteModalDashboard.shows(type, id)
        },
        
        handleTabSwitch(type) {
            this.spacesStatus = type
            this.dashboardStore.setStatus(this.spacesStatus)  
        }
    }

}
</script>

<style scoped>
    .grid-container {
        display: grid;
        grid-template-columns: auto 1fr;
        gap: var(--base-value-2);
        width: 100%;
    }

    .cell {
        display: flex;
        align-items: center;
    }

    .content-width {
        white-space: nowrap;
    }

    .summary-panel {
        background-color: var(--color-primary-10);
    }

    .summary-widget {
        background-color: var(--color-secondary-10);
    }    
</style>